<template>
	<div class="shenming-wrap" v-if="show">
		<div class="shenming">
			<h2><span>{{ En ? 'Declaration' : '严正申明'}}</span></h2>
			<p v-html="data['content' + En]"></p>
			<img class="icon" src="@/assets/images/shenming-icon.png" alt="">
			<img class="close" @click="show = false" src="@/assets/images/shenming-close.png" alt="">
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
import moment from "moment"

export default {
    name: "display",
    data() {
        return {
            data: '',
			show: false
        };
    },
	created() {
		protal.getStatementDetail().then(res => {
			this.data = res.data || {}
		})
		const wapshenming = localStorage.getItem('wapshenming') || 0
		if ( wapshenming < new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime() ) {
			localStorage.setItem('wapshenming', new Date().getTime())
			this.show = true
		}
	}
}
</script>

<style lang="less" scoped="scoped">
.shenming-wrap {
	position: fixed;
	z-index: 99999;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	&::before {
		content: "";
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background: rgba(5,14,27,0.5);
		backdrop-filter: blur(2px);
	}

	.shenming {
		position: relative;
		z-index: 1;
		width: 6.3rem;
		background: url('~@/assets/images/shenmingbg.png') no-repeat;
		background-color: #FAF4F2;
		background-size: 100% auto;
		background-position: 0 bottom;
		padding: .4rem .36rem 1.68rem;
		border-radius: .28rem;

		h2 {
			text-align: center;
			margin-bottom: .28rem;

			span {
				background: #FC581C;
				font-size: .4rem;
				font-weight: 800;
				color: #FFFFFF;
				line-height: .6rem;
				padding: 0 .3rem;
			}
		}

		/deep/ .ql-align-center {
			margin: 0 auto;
			font-size: .24rem;
			font-family: syn;
			color: #333333;
			line-height: .36rem;
			margin-bottom: .32rem;

			&:last-child {
				margin-bottom: 0;
			}

			&:nth-last-child(2) {
				margin-bottom: 0;
			}

			a {
				color: #333333 !important;
				font-family: syn;
			}
		}

		.bottom {
			margin: 0 auto;
			font-size: .24rem;
			text-align: right;
			font-family: syn;
			font-weight: bold;
			color: #333333;
			line-height: .36rem;
			white-space: nowrap;
		}

		.icon {
			position: absolute;
			left: .4rem;
			bottom: 2.4rem;
			width: .69rem;
		}

		.close {
			position: absolute;
			right: .24rem;
			top: .24rem;
			width: .31rem;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/shenmingWap.vue